import { GET_PHONECONSULTNOTE, GET_ADMIN_PHONECONSULTNOTE } from "./constants";

const initSetting = {
  progress_note_setting: {},
  phone_consult_note_details: [],
  phone_consult_notes: [],
  admin_phone_consult_notes: [],
};

// eslint-disable-next-line import/prefer-default-export
export const phoneConsultNoteReducer = (state = initSetting, action = {}) => {
  switch (action.type) {
    case GET_PHONECONSULTNOTE: {
      return {
        ...state,
        phone_consult_notes: action.payload,
      };
    }
    case GET_ADMIN_PHONECONSULTNOTE: {
      return {
        ...state,
        admin_phone_consult_notes: action.payload,
      };
    }
    default:
      return state;
  }
};
